import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import moment from 'moment-timezone'
import { connect } from 'react-redux'
import { Box } from '@material-ui/core'
import { Breadcrumb, Loader, DisplayMessage } from '../../Components'
import { Cards } from '../../elements'
import EventHeader from './eventHeader'
import EventHighlights from './eventHighlights'
import EnergyGraph from './energyGraph'
import { useStyles } from './styles'
import EventMaps from './eventMaps'
import { eventService } from '../../Services'
import { SUCCESS, ERROR } from '../../utils/messageTypes'
import { getProgramById } from '../../AppRedux/actions/Programs'
import { UPCOMING_EVENT } from './constant'
import { SOMETHING_WENT_WRONG } from '../../Constants/MessagesConstant'
import Error404 from '../ErrorPages/Error404'
import SystemsInfo from './SystemsInfo'
import EnergyPowerInfo from './EnergyPowerInfo'
import EnergyPowerGraph from './EnergyPowerGraph'
import { getProgramDetailsEventFlagValue } from '../programs/utils'

function EventDetails(props) {
  const classes = useStyles()
  const [eventId, setEventId] = useState('')
  const [eventDetails, setEventDetails] = useState({})
  const [loading, setLoading] = useState(false)
  const [showMessage, setShowMessage] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState(SUCCESS)
  const [ongoingStoppable, setOngoingStoppable] = useState(false)
  const [upcomingStoppable, setUpcomingStoppable] = useState(false)
  const [mapSiteDetails, setMapSites] = useState([])
  const [graphData, setGraphData] = useState([])
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    setShowMessage(_.get(props.location, 'showMessage', false))
    setMessage(_.get(props.location, 'message', ''))
    setMessageType(_.get(props.location, 'messageType', SUCCESS))
  }, [props.location])

  useEffect(() => {
    const id = _.get(props.match.params, 'programs_id', '')

    if (props.accountId && id && id !== props.programId) {
      props.getProgramById({
        accountId: props.accountId,
        programId: id
      })
    }
  }, [props, props.match.params])

  useEffect(() => {
    const id = _.get(props.match.params, 'event_id', '')
    if (id) {
      getEventDetails(id)
    }

    setEventId(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const featureFlags = _.get(props.programDetails, 'feature_flags', {})
    const isOngoingStoppable = getProgramDetailsEventFlagValue(props.programDetails, 'event_ending_allowed_for_ongoing_event', true)
    const isUpcomingStoppable = getProgramDetailsEventFlagValue(props.programDetails, 'event_cancellation_allowed_for_upcoming_events', true)
    setOngoingStoppable(isOngoingStoppable)
    setUpcomingStoppable(isUpcomingStoppable)
  }, [props.programDetails])

  const errCb = (err) => {
    setLoading(false)
    setShowMessage(true)
    setMessage(_.get(err, 'error.displayMessage', SOMETHING_WENT_WRONG))
    setMessageType(ERROR)
  }


  const getEventDetails = (id) => {
    setLoading(true)
    eventService.getEventById(props.accountId, id)
      .then(response => {
        setEventDetails(response)
        setLoading(false)
        const siteDetails = _.cloneDeep(_.get(response, 'site_details', []))
        let mapSites = siteDetails || []
        mapSites = mapSites.map(obj => {
          const id = _.get(obj, 'site_id', '')
          const optInSites = _.get(response, 'opted_in_sites', [])
          if (optInSites.some(list => list === id)) {
            return {
              ...obj,
              type: 'optIn'
            }
          } else {
            return {
              ...obj,
              type: 'optOut'
            }
          }
        })
        setMapSites(mapSites)
        getEnergyPowerData(id)
      })
      .catch((err) => {
        if (err.error.code === '400') {
          setNotFound(true)
        } else {
          errCb(err)
        }
      })
  }

  const getEnergyData = (id) => {
    setLoading(true)
    eventService.getEventEnergyData(props.accountId, id)
      .then(response => {
        setLoading(false)
        setGraphData(response)
      })
      .catch((err) => {
        errCb(err)
      })
  }

  const getEnergyPowerData = (id) => {
    setLoading(true)
    eventService.getEventEnergyPowerData(props.accountId, id)
      .then(response => {
        setLoading(false)
        setGraphData(response)
      })
      .catch((err) => {
        setGraphData([])
        errCb(err)
      })
  }

  const handleSystemClick = () => {
    setTimeout(() => {
      const element = document.getElementById('systems_wrapper')
      element.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }, 200)
  }

  const handleCancelEvent = () => {
    setLoading(true)
    eventService.cancelEventById(props.accountId, eventId)
      .then(response => {
        setLoading(false)
        getEventDetails(eventId)
      })
      .catch(error => {
        errCb(error)
      })
  }

  const renderHighlightsAndGraph = () => {
    const eventDetailStatus = _.get(eventDetails, 'status', '')
    const startTime = _.get(eventDetails, 'start_date_time', '')
    const shouldShowGraph = moment().tz(props.timeZone).isBefore(moment(startTime).tz(props.timeZone)) || eventDetailStatus !== UPCOMING_EVENT
    return (
      <Box>
        <EventHighlights data={eventDetails} programId={props.programId} handleSystemClick={handleSystemClick} timeZone={props.timeZone} />
        {eventDetails && eventDetails.status !== 'cancelled' && <EnergyPowerInfo data={eventDetails} programId={props.programId} />}
        {/* {shouldShowGraph && <EnergyGraph graphData={graphData} eventDetails={eventDetails} timeZone={props.timeZone} />} */}
        {shouldShowGraph && eventDetails && eventDetails.status !== 'cancelled' && <EnergyPowerGraph graphData={graphData} eventDetails={eventDetails} timeZone={props.timeZone} eventId={eventId} />}
        <SystemsInfo data={eventDetails}/>
      </Box>
    )
  }

  const renderLocation = () => {
    return (
      <Box id="events_wrapper">
        <EventMaps data={mapSiteDetails} programId={props.programId} eventDetails={eventDetails} />
      </Box>
    )
  }

  const renderBreadCrumbValue = () => {
    const nav = [{ 'Home': '/' }, { 'Programs': '/programs' }]
    nav.push(
      { [_.get(props.programDetails, 'program_name_admin_ui', '')]: `/programs/${props.programId}` },
      { 'Events': `/programs/${props.programId}/events` },
      { [_.get(eventDetails, 'name', '')]: '' }
    )
    return nav
  }

  return (
    <Box>
      {notFound ? <Error404 /> :
        <>
          <Breadcrumb value={renderBreadCrumbValue()} />
          <EventHeader eventDetails={eventDetails} cancelEvent={handleCancelEvent} ongoingStoppable={ongoingStoppable} upcomingStoppable={upcomingStoppable} timeZone={props.timeZone} programDetails={props.programDetails} />
          <Cards children={renderHighlightsAndGraph()} className={classes.cardWrapper} />
          <Cards children={renderLocation()} className={classes.cardWrapper} />
          <Loader loading={loading} />
          <DisplayMessage open={showMessage} message={message} messageType={messageType} handleClose={() => setShowMessage(false)} />
        </>
      }
    </Box>
  )
}

const mapDispatchToProps = (dispatch) => ({
  getProgramById: (payload) => dispatch(getProgramById(payload)),
})

const mapStateToProps = ({ auth, programs }) => {
  const { accountId, timeZone } = auth
  const { programDetails, programId } = programs
  return { accountId, programDetails, programId, timeZone }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventDetails)
